/**
 * The card grid inside each half of the "what is backed up / where it goes" block.
 *
 * The two halves sit side by side from `lg` up, so each is half the width a full-width panel had:
 * two cards to a row while the halves are stacked, one while each is half of a laptop screen, and
 * two, then three, again only once a half is wide enough to hold them. Held as one literal because
 * Tailwind scans the source for whole class names, and so the two halves cannot drift apart.
 */
export const SETUP_CARD_GRID =
  'grid grid-cols-1 gap-3 px-4 pb-4 sm:grid-cols-2 lg:grid-cols-1 2xl:grid-cols-2 min-[2200px]:grid-cols-3';
